<script setup>
import { EventManager, Actions, Events } from "@events";
import { onMounted, ref } from 'vue';
import { useVideoCallState } from "@/stores/videoCallState";
import { useDeviceState } from "@/stores/deviceState";
import { getCameras } from "@/utils";

const props = defineProps({
    rtcId: {
        type: String,
        required: true,
    }
});

const state = useVideoCallState(props.rtcId);
const deviceState = useDeviceState();
let eventEmitter = null;
let actionEmitter = null;

const localPeer = ref(null);
const isCameraSwitched = ref(false);
const cameras = ref([]);

async function switchCamera(){
    if(cameras.value?.length > 0){
        try {
            const deviceId = cameras.value?.pop()?.deviceId;
            if(!deviceId) return false;
            
            await deviceState.setCameraId(deviceId);
            return true;
        }
        catch(error){
            console.error(error);
            return await switchCamera();
        }
    }
    else {
        try {
            await deviceState.setCameraId(undefined);
        }
        catch(error){
            console.error(error);
        }

        return false;
    }
}

onMounted(() => {
    if(state.role == 'agent') return;

    eventEmitter = EventManager.getEventEmitter(props.rtcId);
    actionEmitter = EventManager.getActionEmitter(props.rtcId);

    localPeer.value = state.peers.find((peer) => peer.type === "local");
    
    eventEmitter.on(Events.TextChannelMessageSent, async ({ data }) => {
        if (data.startsWith("CAMERASTATUS|")) {
            const parts = data.split("|");

            if (parts[1] == "b") { 
                if(isCameraSwitched.value) return;

                cameras.value = await getCameras("back");
                if(cameras.value.length == 0) return;

                console.log("Switching video input to back camera.");

                isCameraSwitched.value = await switchCamera();
            }
            else if(parts[1] == "f"){
                if(!isCameraSwitched.value) return;

                cameras.value = await getCameras("front");
                if(cameras.value?.length > 1) cameras.value.reverse(); // Reverse the order of the cameras array, because we are using array.pop() to get the last camera, and the first one needed to be last in this case (because we want the first one when choosing front camera).

                console.log("Switching video input to front camera.");

                await switchCamera();
                isCameraSwitched.value = false;
            }
        }
    });
});

</script>

<template></template>
  